
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ContactDetailsGrid extends Serenity.EntityGrid<ContactDetailsRow, any> {
        protected getColumnsKey() { return 'OMS.ContactDetails'; }
        protected getDialogType() { return ContactDetailsDialog; }
        protected getIdProperty() { return ContactDetailsRow.idProperty; }
        protected getInsertPermission() { return ContactDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return ContactDetailsRow.localTextPrefix; }
        protected getService() { return ContactDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}